import TopNavbar from 'src/components/Dashboard/Layout/TopNavbar/TopNavbar.vue'
import MenuAdmin from 'src/components/Dashboard/Menu/MenuAdmin/MenuAdmin.vue'
import MenuUtilisateur from 'src/components/Dashboard/Menu/MenuUtilisateur/MenuUtilisateur.vue'
import messages from './DashboardLayout.json'
const { detect } = require('detect-browser');

export default {
    name: 'DashboardLayout',
    i18n: messages,
    components: {
        TopNavbar,
        MenuAdmin,
        MenuUtilisateur
    },

    data() {
        return {
            displayLoading: false
        };
    },

    created() {
        this.$eventHub.$on(this.$eventHub.LOADING.START, () => { this.displayLoading = true });
        this.$eventHub.$on(this.$eventHub.LOADING.END, () => { this.displayLoading = false });
        this.$eventHub.$off(this.$eventHub.SEND_LOG);
        this.$eventHub.$on(this.$eventHub.SEND_LOG, this.sendLog);
        this.$eventHub.$off(this.$eventHub.SHOW_NOTIF);
        this.$eventHub.$on(this.$eventHub.SHOW_NOTIF, this.showNotif);
    },

    beforeDestroy: function () {
        this.$eventHub.$off(this.$eventHub.SEND_LOG, this.sendLog);
        this.$eventHub.$off(this.$eventHub.SHOW_NOTIF);
    },

    methods: {
        toggleSidebar() {
            if (this.$val.isDefined(this.$sidebar) && this.$sidebar.showSidebar) {
                this.$sidebar.displaySidebar(false)
            }
        },
        /**
         * Permet d'enregistrer une action faite par un user
         * @param {} request
         */
        sendLog: function (nomLog, comLog) {
            this.$eventHub.$emit(this.$eventHub.LOADING.START)
            const browser = detect();
            let requestDTO = {
                nomLog: nomLog,
                commentaire: comLog,
                nomNavigateur: browser.name,
                versionNavigateur: browser.version
            }
            this.$axios.post('rest/bd/logs/', requestDTO).then(
                response => {
                    this.$eventHub.$emit(this.$eventHub.LOADING.END);
                },
                error => {
                    console.error(error.response)
                    this.$eventHub.$emit(this.$eventHub.LOADING.END);
                }
            )
        },

        /** Permet d'afficher une notif */
        showNotif: function(type, titre, message) {
            this.$notify({
                title: titre,
                message: message,
                horizontalAlign: 'right',
                verticalAlign: 'top',
                type: type, // info | warning | error | success | primary
                timeout: 5000,
                closeOnClick: true
            })
        }
    }
}